import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { batchRequest, getRequest } from '../../../../../../api/ApiService';
import { teamsEndpoint } from '../../../../../../api/Teams';
import Auth from '../../../../../../routes/Auth';

import { handleSelectChange, arrayUniqueFilter, formatMillionsValue } from '../../../utils';

import BannerLayout from '../../../layouts/banner';
import AbbreviatedMillionNumberFormat from "../../../../../../components/ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";

import {
  FormulaName,
  FormulaValue
} from '../../../components/ui';

class ROAStep2 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      averageTotalAssets: 0,
      totalAssets: 0,
      netIncome: 0,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, rounds, gamesTargets, performanceFeedbacksGame } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;
    const prevRound = rounds.find(i => i.number === activeRound - 1);
    const prevRoundId = prevRound ? prevRound.id : 0;

    getRequest(
      teamsEndpoint()
    ).then(res => {
      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Roa fail").teams.filter(arrayUniqueFilter);

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      batchRequest([
        `${process.env.REACT_APP_API_URL}team/report/balance_sheet/?round_lte=${activeRound}&team_id=${team_id}`,
        `${process.env.REACT_APP_API_URL}team/report/income_statement/?round_number=${activeRound}&team_id=${team_id}`,
      ])
        .then(res => {
          const balanceSheet = res[0].body;
          const currentRoundBalanceSheet = balanceSheet.find(i => i.round === roundId);
          const prevRoundBalanceSheet = balanceSheet.find(i => i.round === prevRoundId);

          let totalAssets = currentRoundBalanceSheet ? Number(currentRoundBalanceSheet['Total Assets'] || 0) : 0;
          if (prevRoundBalanceSheet) {
            const prevTotalAssets = Number(prevRoundBalanceSheet['Total Assets'] || 0);
            totalAssets = (totalAssets + prevTotalAssets) / 2;
          }

          const incomeStatement = res[1].body;
          const currentRoundIncomeStatement = incomeStatement.find(i => i.round === roundId);
          const netIncome = currentRoundIncomeStatement ? Number(currentRoundIncomeStatement['Net Income'] || 0) : 0;

          const roaTarget = Number(gamesTargets[0].roa || 0);

          this.setState({
            loaded: true,
            teamsToShow,
            selectedTeamId: Number(team_id),
            allTeamsCount: teams.length,
            averageTotalAssets: totalAssets * roaTarget,
            totalAssets,
            netIncome: netIncome,
          })
        })
        .catch(err => { });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      averageTotalAssets,
      totalAssets,
      netIncome,
    } = this.state;

    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="ROA"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams did not generate enough profits`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            <p>Given your average total assets, your company needed to generate {formatMillionsValue(averageTotalAssets)} in net profits in order to hit your ROA target.</p>
            <p><strong>Common reasons why teams are unable to maximize profits:</strong></p>
            <p><strong>Revenue Challenges:</strong> A mix of marketing mix and/or capacity challenges might have led to lower revenues (e.g. lower ranking products, less productive machines).</p>
            <p><strong>Operating Margin Challenges:</strong> There’s likely margin compression since selling prices do not change, but costs are likely rising from round to round as teams upgrade their products to be more competitive. Those who updgraded their products.</p>
            <p><strong>High Financing Costs:</strong> Some teams took on a lot of debt in the earlier rounds and are unable to repay. They are feeling the impact now as a result of the metrics shifting to profit driven metrics.</p>
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <FormulaName background="#5c91f5">
              Return on Assets<br />
              (ROA)
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              Net Profits
              <span className='divider' />
              Average Total Assets
            </FormulaValue>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue>
              <AbbreviatedMillionNumberFormat
                value={netIncome}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
              <span className='divider' />
              <AbbreviatedMillionNumberFormat
                value={totalAssets}
                prefix="$"
                negativeClass="negative-value"
                floatCount={2}
              />
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#D5D9DD',
          background: '#E6EDFB',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default ROAStep2;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/roa/step2.js